import styled from 'styled-components';

import DotsIcon from '@asset/dots.icon.svg?react';

export const Dots = styled(DotsIcon)`
  cursor: pointer;
`;
